export default {
  DEFAULT_OPTIONS: {
    title: 'Thông báo',
    solid: true,
    toaster: 'b-toaster-top-right',
    autoHideDelay: 3000,
  },

  TOAST_TYPES: {
    SUCCESS: 'success',
    ERROR: 'danger',
    WARNING: 'warning',
    INFO: 'info',
  },

  showToast(vm, type, message, options = {}) {
    vm.$bvToast.toast(message, {
      ...this.DEFAULT_OPTIONS,
      variant: type,
      ...options,
    });
  },

  success(vm, message, options = {}) {
    this.showToast(vm, this.TOAST_TYPES.SUCCESS, message, options);
  },

  error(vm, message, options = {}) {
    this.showToast(vm, this.TOAST_TYPES.ERROR, message, options);
  },

  warning(vm, message, options = {}) {
    this.showToast(vm, this.TOAST_TYPES.WARNING, message, options);
  },

  info(vm, message, options = {}) {
    this.showToast(vm, this.TOAST_TYPES.INFO, message, options);
  },
};
